import React, { memo, useMemo, useRef } from 'react'
import Classnames from 'classnames'
import styled from '@emotion/styled'

// state
import { useRecoilState, useRecoilValue } from 'recoil'
import {
  isBuilder,
  screen,
  screenOpen,
  editSectionId,
  editSectionWrapperId,
} from '@/store/builder/store'

import { section } from '@/store/template/section'

import { StatefulTooltip } from 'baseui/tooltip'

// icons
import * as RemixIcon from 'react-icons/ri'

function SectionTitle({ id, title, prompt, wrapperId }) {
  const isBuilderApp = useRecoilValue(isBuilder)
  const [getSreen, setScreen] = useRecoilState(screen)
  const [getScreenOpen, setScreenOpen] = useRecoilState(screenOpen)
  const [getEditSectionId, setEditSectionId] = useRecoilState(editSectionId)
  const [getEditSectionWrapperId, setEditSectionWrapperId] =
    useRecoilState(editSectionWrapperId)
  const [getSection, setSection] = useRecoilState(section(id))

  const tooltipRef = useRef()

  const TitleWrapper = styled.div`
    --title-border-color: ${getSection.title_color} !important;
  `

  let IconComponent = RemixIcon['RiFileEditLine']

  if (getSection.icon !== 'noicon') {
    IconComponent = RemixIcon[getSection.icon]
  }

  const openEditor = () => {
    if (isBuilderApp) {
      setScreen('editsection')
      setScreenOpen(true)
      setEditSectionId(id)
      setEditSectionWrapperId(wrapperId)
    }
  }
  return (
    <TitleWrapper
      className={Classnames('boxTitleBlock flex-shrink-0', {
        boxTitleBlockEmpty: title == '' && prompt == '',
        noLeftBorder: getSection.title_color == '#FFF',
      })}
    >
      {/* edit icon - make better */}
      {isBuilderApp && (
        <div
          onClick={openEditor}
          className="editSectionIcon shadow-lg bg-white text-black opacity-0 absolute top-3 right-3  hover:opacity-100  p-1 text-lg rounded  hover:bg-blue-500 hover:text-white cursor-pointer"
          style={{ zIndex: '999999' }}
        >
          <RemixIcon.RiSettings5Line />
        </div>
      )}

      <div
        className={Classnames(
          'boxTitleBlockInner flex items-center justify-between  transition ease-in-out duration-300 transform',
          {
            'flex-row-reverse':
              getSection.icon !== 'noicon' && getSection.iconalign == 'right',
          }
        )}
      >
        {/* OPTIONAL ICON */}
        {getSection.icon !== 'noicon' && (
          <div
            className={Classnames(
              'sectionIcon h-16 w-16 flex-shrink-0 text-4xl flex items-center justify-center',
              {
                'mr-4': getSection.iconalign == 'left',
                'ml-4': getSection.iconalign == 'right',
                rounded: getSection.iconstyle == 'square',
                'rounded-full': getSection.iconstyle == 'circle',
                ' bg-gray-100 text-gray-600': getSection.iconcolor == 'gray',
                ' bg-blue-100 text-blue-500': getSection.iconcolor == 'blue',
                ' bg-green-100 text-green-600': getSection.iconcolor == 'green',
                ' bg-red-100 text-red-600': getSection.iconcolor == 'red',
                ' bg-purple-100 text-purple-600':
                  getSection.iconcolor == 'purple',
                ' bg-pink-100 text-pink-600': getSection.iconcolor == 'pink',
                ' bg-indigo-100 text-indigo-600':
                  getSection.iconcolor == 'indigo',
                ' bg-yellow-100 text-yellow-600':
                  getSection.iconcolor == 'yellow',
                ' bg-gray-600 text-gray-50': getSection.iconcolor == 'darkgray',
                ' bg-green-500 text-green-50':
                  getSection.iconcolor == 'darkgreen',
                ' bg-blue-500 text-blue-50': getSection.iconcolor == 'darkblue',
                ' bg-red-500 text-red-50': getSection.iconcolor == 'darkred',
                ' bg-purple-500 text-purple-50':
                  getSection.iconcolor == 'darkpurple',
                ' bg-pink-500 text-pink-50': getSection.iconcolor == 'darkpink',
                ' bg-indigo-500 text-indigo-50':
                  getSection.iconcolor == 'darkindigo',
                ' bg-yellow-400 text-yellow-50':
                  getSection.iconcolor == 'darkyellow',

                ' text-gray-700':
                  getSection.iconcolor == 'darkgray' &&
                  getSection.iconstyle == 'icononly',
                ' text-green-700':
                  getSection.iconcolor == 'darkgreen' &&
                  getSection.iconstyle == 'icononly',
                ' text-blue-700':
                  getSection.iconcolor == 'darkblue' &&
                  getSection.iconstyle == 'icononly',
                ' text-red-700':
                  getSection.iconcolor == 'darkred' &&
                  getSection.iconstyle == 'icononly',
                ' text-purple-700':
                  getSection.iconcolor == 'darkpurple' &&
                  getSection.iconstyle == 'icononly',
                ' text-pink-700':
                  getSection.iconcolor == 'darkpink' &&
                  getSection.iconstyle == 'icononly',
                ' text-indigo-700':
                  getSection.iconcolor == 'darkindigo' &&
                  getSection.iconstyle == 'icononly',
                ' text-yellow-700':
                  getSection.iconcolor == 'darkyellow' &&
                  getSection.iconstyle == 'icononly',
                sectionIconNoBG: getSection.iconstyle == 'icononly',
              }
            )}
          >
            <IconComponent />
          </div>
        )}

        {/* TITLE & PROMPT  */}
        <div className="flex-grow">
          <div className="titleText font-bold leading-tight -mt-1">{title}</div>
          <div className="promptText">{prompt}</div>
        </div>
      </div>
    </TitleWrapper>
  )
}

export default SectionTitle
